module.exports = __webpack_public_path__ + "img/diagonal_distance_icon.03564301.png";